import SearchComponent from "../../components/search.component";
import ExportComponent from "../../components/export.component";
import {SORT_LIST_REVIEW_DETAIL} from "../../utils/sort-list";
import {useDispatch, useSelector} from "react-redux";
import {useFetch} from "../../services/useFetch";
import {API} from "../../services/api";
import {useParams} from "react-router-dom";
import {downloadFileExport} from "../../utils/general-variable";
import moment from "moment";
import SortComponent from "../../components/sort.component";
import PageLimitComponent from "../../components/page-limit.component";
import {DATA_LIMIT_LIST} from "../../utils/filter-list";
import React from "react";
import {setToolsModalVisibility} from "../../reducers/tools.reducer";

const ReviewDetailFilter = () => {
    const dispatch = useDispatch()
    const {
        orderBy,
        sort,
        searchKey
    } = useSelector(state => state.toolsReducer)
    const {activeTab, activeSidebar, selectedRowKeysReview} = useSelector(state => state.reviewReducer)
    const {id} = useParams()
    const {fetching: exportProductReviewDetail, isLoading} = useFetch({...API.EXPORT_PRODUCT_REVIEW_DETAIL, ...{initPathVariable: id}})

    const exportDataHandler = () => {
        const body = {
            order_by: orderBy,
            order_type: sort,
            search: searchKey,
            filter_by_criteria: activeTab,
            filter_by_user_choice: activeSidebar,
            review_ids: selectedRowKeysReview
        }
        exportProductReviewDetail(body, '', {}, 'blob').then(res => {
            downloadFileExport(res, `Product-Review-Detail-List-Export-${moment().format()}.xlsx`)
        })
        dispatch(setToolsModalVisibility({export: false}))
    }

    return (
        <div className={"row justify-between my-5"}>
            <div className={"row space-x-5"}>
                <SearchComponent placeholder={"cari review, nama user..."}/>
                <div className={"row space-x-3"}>
                    <SortComponent sortList={SORT_LIST_REVIEW_DETAIL}/>
                    <PageLimitComponent limitList={DATA_LIMIT_LIST}/>
                    <div>
                        <ExportComponent
                            wordingConfirmation={`Apakah anda yakin ingin melakukan export data product review detail ?`}
                            countSelected={selectedRowKeysReview.length}
                            exportDataHandler={exportDataHandler}
                            isLoading={isLoading}/>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ReviewDetailFilter
